// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_please_request_a_new_sign_in_link_to_continue_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please request a new sign-in link to continue.`)
};

const en_us2_please_request_a_new_sign_in_link_to_continue_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please request a new sign-in link to continue.`)
};

const de_de2_please_request_a_new_sign_in_link_to_continue_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte fordere einen neuen Anmelde-Link an, um fortzufahren.`)
};

const en_please_request_a_new_sign_in_link_to_continue_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please request a new sign-in link to continue.`)
};

const de_please_request_a_new_sign_in_link_to_continue_1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte fordere einen neuen Anmelde-Link an, um fortzufahren.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const please_request_a_new_sign_in_link_to_continue_1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.please_request_a_new_sign_in_link_to_continue_1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("please_request_a_new_sign_in_link_to_continue_1", locale)
	if (locale === "en-GB") return en_gb2_please_request_a_new_sign_in_link_to_continue_1(inputs)
	if (locale === "en-US") return en_us2_please_request_a_new_sign_in_link_to_continue_1(inputs)
	if (locale === "de-DE") return de_de2_please_request_a_new_sign_in_link_to_continue_1(inputs)
	if (locale === "en") return en_please_request_a_new_sign_in_link_to_continue_1(inputs)
	return de_please_request_a_new_sign_in_link_to_continue_1(inputs)
};
export { please_request_a_new_sign_in_link_to_continue_1 as "Please request a new sign-in link to continue." }